export const networking = {
  'QrBadge': 'QR Badge',
  'seeAll': 'Visa alla',
  'newcommers': 'New Networkers',
  'checkThemOut': 'Kolla in dem!',
  'topicsToDiscuss': 'Diskussionsämnen',
  'OneOnOneMeet': '1:1 Möte',
  'learnMoreNetworking': 'Läs mer om Networking Hub',
  'scanQrCode': 'Skanna QR-kod',
  'myBadge': 'Min badge',
  'message': 'Meddelande',
  'scannedBadge': 'Scannad badge',
  'viewProfile': 'Visa profil',
  'userRatingDetails': 'Användarrecensioner',
  'networkingHub': 'Networking Hub',
  'totalScore': 'Totalt resultat:',
  'scoreComposedOf': 'Denna poäng består av:',
  'confirmationText': 'Är du säker? Detta kan inte ångras.',

  'welcomeMessage': 'Välkommen till <strong>Networking Hub</strong>, där kopplingar blir verklighet! Här är hur det fungerar:',
  'connectingMadeSimpleTitle': 'Enkla kopplingar',
  'connectingMadeSimpleDescription':
    'Networking Hub erbjuder strukturerade aktiviteter och nivåer för att hjälpa dig att koppla ihop effektivt:',

  'newcomersDescription':
    '<strong>Newcomers:</strong> Utforska profiler av nykomlingar, välj intressanta och skicka meddelanden. Du kan även koppla ihop med dem personligen.',
  'shortlistDescription': '<strong>Shortlist:</strong> När du visar intresse för någon, läggs de till i din lista.',
  'contactedConnectedDescription':
    '<strong>Contacted/Connected:</strong> När du tar kontakt och får ett svar, går de till dessa kategorier.',
  'skipDescription': '<strong>Skip:</strong> Inte intresserad? Hoppa bara över profilen och fortsätt!',

  'enhancedNetworkingActivitiesTitle': 'Förbättrade nätverksaktiviteter',
  'enhancedNetworkingActivitiesDescription': 'Förutom direkta kopplingar, innehåller Huben:',

  'topicsToDiscussDescription':
    '<strong>Topics to Discuss:</strong> Utforska ämnen som intresserar dig och koppla ihop med författare eller deltagare. Delta i online-diskussioner eller schemalägg gruppmöten för att fördjupa dessa ämnen.',
  'oneOnOneMeetingPlannerDescription':
    '<strong>1:1 Meeting Planner:</strong> Hantera mötesförfrågningar, spåra planerade möten och organisera ditt schema enkelt.',

  'gamificationTitle': 'Gamification för roligheter och engagemang',
  'gamificationDescription':
    'Öka din aktivitet med ett leaderboard som spårar dina poäng och visar de mest aktiva nätverkarna. Så här kan du tjäna poäng:',

  'pointsSystem': {
    points1000ProfileComplete: '<strong>1 000 poäng:</strong> Fyll i din profil (inklusive foto).',
    points1000PushNotifications: '<strong>1 000 poäng:</strong> Aktivera push-notifikationer.',
    points100SendMeetingRequest: '<strong>100 poäng:</strong> Skicka en 1:1 mötesförfrågan.',
    points400GetAcceptedRequest: '<strong>400 poäng:</strong> Få din 1:1 mötesförfrågan accepterad.',
    points400AcceptRequest: '<strong>400 poäng:</strong> Acceptera en 1:1 mötesförfrågan.',
    points100DeclineRequest: '<strong>100 poäng:</strong> Avvisa en 1:1 mötesförfrågan.',
    points400CreateDiscussion: '<strong>400 poäng:</strong> Skapa ett diskussionsämne.',
    points50LikeDiscussion: '<strong>50 poäng:</strong> Gilla ett diskussionsämne.',
    points200PostFirstComment: '<strong>200 poäng:</strong> När du postar din första kommentar på ett annat ämne.',
    points100LikeOnTopic: '<strong>100 poäng:</strong> Få ett gillande på ditt ämne.',
    points200UniqueCommenter: '<strong>200 poäng:</strong> Få en unik kommentator på ditt ämne.',
    points100LikeShortlistUser: '<strong>100 poäng:</strong> Gilla/lägg till en användare till din shortlist.',
    points50SkipUser: '<strong>50 poäng:</strong> Hoppa över en användare.',
    points200StartChat: '<strong>200 poäng:</strong> Starta en chatt (kontaktad).',
    points300GetChatResponse: '<strong>300 poäng:</strong> Få svar i en chatt (ansluten).',
    points400RespondToChat: '<strong>400 poäng:</strong> Svara på en chattförfrågan (ansluten).',
    points500SpeedNetworking: '<strong>500 poäng:</strong> För varje snabbnätverkssession.'
  },

  'finalMessage':
    'Maximera din upplevelse med Networking Hub, upptäck nya möjligheter och klättra på leaderboarden när du kopplar upp och engagerar dig med likasinnade professionella!',

  'manageMeeting': 'Hantera möte',
  'addToCalendar': 'Lägg till i kalendern',
  'cancel': 'Avbryt',
  'accept': 'Acceptera',
  'accept&addToCalendar': 'Acceptera och lägg till i kalendern',
  'editDetails': 'Redigera detaljer',
  'reject': 'Avvisa',
  'delete': 'Ta bort',
  'exportContact': 'Exportera kontakt',
  'scheduleNewOneOnOne': 'Schemalägg en ny 1:1',
  'initiatedBy': 'Initierad av',
  'rejectedBy': 'Avvisad av',
  'you': 'du',
  'meetPassed': 'Mötet har passerat',
  'meetInProgress': 'Pågår',

  'myOneOnOne': 'Min 1:1',

  'speed': {
    history: 'Historia',
    minutes: 'min.',
    users_available: 'tillgängliga',
    rules: 'Regler',
    activate: 'Aktivera',
    matching: 'Matchning...',
    start: 'Starta',
    find_a_user: 'Hitta en användare med samma bild',
    find_a_user_number: 'Hitta en användare med samma nummer',
    waiting: 'Väntar...',
    speaking_now: 'Talar nu',
    networking_topics: 'Nätverksämnen',
    session_ended: 'Sessionen avslutad',
    find_next_partner: 'Hitta nästa partner',
    find_next_group: 'Hitta nästa grupp',
    partner_wasnt_ready: 'Partnern var inte redo',
    partner_wasnt_ready_description: 'Det verkar som att partnern inte var redo för diskussion. Låt oss hitta en ny!',
    start_matching: 'Starta matchning'
  }
}
